<template>
  <md-dialog v-bind="$attrs" v-on="$listeners" 
             :md-fullscreen="false"
             :md-click-outside-to-close="false"
             :md-close-on-esc="false">
    <md-dialog-title v-if="mdTitle">{{ mdTitle }}</md-dialog-title>
    <md-dialog-content>
      <form class="md-layout md-alignment-center-center" autocomplete="off">
        <div class="md-layout-item md-size-90 md-small-size-100">
          <span>ユーザーへシカクマップのIDとパスワードをメールで送信しますか？</span><br/>
          <md-radio v-model="form.send_password" :value="true">送信する</md-radio>
          <md-radio v-model="form.send_password" :value="false">送信しない</md-radio>
        </div>
        <div class="md-layout-item md-size-90 md-small-size-100">
          <span class="md-caption" v-if="form.send_password">
            ※ {{ email }} にシカクマップログインID、パスワードを送信します。<br>
            ※ 登記情報提供サービスIDとパスワードについては通知されません。
          </span>
          <span class="md-caption" v-else>
            ※ パスワードは「登録する」をクリックする前にメモなどで残しておいてください。
          </span>
        </div>
      </form>
    </md-dialog-content>

    <md-dialog-actions>
      <md-button :class="'md-raised ' + cancelButtonClass" @click="onCancel">
        <md-icon>close</md-icon>
        <span>{{ mdCancelText }}</span>
      </md-button>
      <md-button :class="'md-raised md-primary ' + confirmButtonClass" @click="onConfirm">
        <md-icon>check</md-icon>
        <span>{{ mdConfirmText }}</span>
      </md-button>
    </md-dialog-actions>
    <loading-spinner-overlay v-if="sending"></loading-spinner-overlay>
  </md-dialog>
</template>

<script>
import LoadingSpinnerOverlay from "./LoadingSpinnerOverlay";
import CommonMixin           from "../mixins/commonMixin";
import Common                from "../modules/common";

export default {
  name      : 'ConfirmAccountRegistrationModal',
  components: {LoadingSpinnerOverlay},
  mixins    : [CommonMixin],
  props     : {
    mdTitle           : String,
    mdContent         : String,
    mdConfirmText     : {
      type   : String,
      default: 'OK'
    },
    mdCancelText      : {
      type   : String,
      default: '戻る'
    },
    confirmButtonClass: {
      type   : String,
      default: null,
    },
    cancelButtonClass : {
      type   : String,
      default: null,
    },
    email             : {
      type    : String,
      required: false,
      default : null,
    },
    password          : {
      type    : String,
      required: false,
      default : null,
    },
    display           : {
      type    : Boolean,
      required: true,
      default : false,
    },
  },
  data      : () => ({
    form  : {
      send_password  : false,
      password       : null,
      passwordConfirm: null,
    },
  }),
  watch  : {
    display: function () {
      this.sending = false;
      if (this.display) {
        const auth              = JSON.parse(localStorage.getItem(Common.localStorageKeys.user.auth));
        const sendPassword      = localStorage.getItem(Common.localStorageKeys.user.sendPasswordAccountCreated + auth.corporation.id);
        this.form.send_password = sendPassword === 'true';
        this.form.password      = this.$props.password;
      }
    },
  },
  methods: {
    onCancel() {
      this.$emit('md-cancel');
      this.$emit('update:mdActive', false)
    },
    onConfirm() {
      this.sending = true;
      const auth   = JSON.parse(localStorage.getItem(Common.localStorageKeys.user.auth));
      localStorage.setItem(Common.localStorageKeys.user.sendPasswordAccountCreated + auth.corporation.id, this.form.send_password);
      this.$emit('md-confirm', this.form.send_password);
    },
  }
}
</script>
